import React from 'react';
interface LogoProps {
  className?: string;
}
// Official Independence Home Loans logo (white version) — used on the navy sidebar.
// Per brand rules the lockup is used as-is and never altered.
export function Logo({
  className = 'h-12'
}: LogoProps) {
  return <img src="https://cdn.magicpatterns.com/uploads/qCw9ixeg3Agv2K25pKNoPr/Independence_Home_Loans_Logo_04_White-4k.png" alt="Independence Home Loans" className={`w-auto object-contain ${className}`} data-id="element-185" />;
}